export default "__VITE_ASSET__36184971__"